var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"test"},[_c('iframe',{attrs:{"src":"https://phet.colorado.edu/sims/html/build-an-atom/latest/build-an-atom_all.html","frameborder":"0"}})])])
}]

export { render, staticRenderFns }